import { useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";

export const useGetUsersListByRole = (role?: string) => {
  const { user, authString } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["users", role, 7],
    staleTime: 120,
    queryFn: async () => {
      const queryString = role ? `?role=${role}` : "";
      const result = await axiosBaseURL.get(`/operation/vce/${queryString}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          // Authorization: authString,
        },
      });

      return result;
    },
  });
};
